import { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { type OperationViewModel } from '../components/Map/types';
import { useDispatch, useTripsContext } from '../components/GlobalContextProvider/GlobalContextProvider';
import { ActionType } from '../components/GlobalContextProvider/global-reducer';

interface Result {
  operationKey: string;
  operation: OperationViewModel;
  setOperation: (operation: string) => void;
}

export const useOperation = (): Result => {
  const { port } = useParams();
  const { operations, port: contextPort } = useTripsContext();
  const [operationIndicator, setOperationIndicator] = useState(port || contextPort);
  const dispatch = useDispatch();

  useEffect(() => {
    if (port && operationIndicator !== port) {
      setOperationIndicator(port);
    }
  }, [port]);

  const [operation, operationKey] = useMemo<[OperationViewModel, string]>(() => {
    if (operations?.length && operationIndicator) {
      const operation = operations.find(
        o =>
          o.key.toLowerCase() === operationIndicator.toLowerCase() ||
          o.name.toLowerCase() === operationIndicator.toLowerCase()
      );
      return [operation, operation?.key ?? operationIndicator];
    }

    return [null, operationIndicator];
  }, [operationIndicator, operations, contextPort]);

  useEffect(() => {
    dispatch({ type: ActionType.UPDATE_OPERATION, payload: operationKey });
  }, [operationKey]);

  return {
    operation,
    operationKey,
    setOperation: setOperationIndicator,
  };
};
